import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Icon, DomEvent, LeafletEvent, Map, LayerGroup, MapOptions, tileLayer, LatLng, latLng, Marker , MarkerClusterGroup, MarkerClusterGroupOptions, divIcon, ZoomAnimEvent, FullscreenOptions, Control, DomUtil, control, marker } from 'leaflet';
import * as moment from 'moment';
import { NoGpsPointsDialogComponent } from 'src/app/features/map/components/no-gps-points.component';
import { mapURL } from 'src/environments/environment.api';

@Component({
  standalone: false,
  selector: 'app-vehicle-last-point-map',
  templateUrl: './vehicle-last-point-map.component.html',
  styleUrls: ['./vehicle-last-point-map.component.scss']
})
export class VehicleLastPointMapComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  @Output() map$: EventEmitter<Map>= new EventEmitter;
  @Output() zoom$: EventEmitter<number>=new EventEmitter;
  zoom!:number;
  public map!: Map;

  /*marker_icon =  Icon.extend({
    options:
      {
        iconSize: [21, 31], // size of the icon
        iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/marker-icon.png'
      }
  })*/

  getCoords():LatLng {
    if(this.data.coords !== null){
      var coord = this.data.coords.split(" ");
      const mark1= coord[1].split("(");
      const mark2= coord[2].split(")");
      const x=mark2[0] as number
      const y= mark1[1] as number
      if (x > y){
        var coords = new LatLng(x as number, y as number)
      } else {
        coords = new LatLng(y as number, x as number)
      }
      return coords
      }
    return new LatLng(45.800084381319905, 13.38134765625)
  }
  mapUrl = mapURL.mapUrl !== '${mapURL}' ? mapURL.mapUrl : mapURL.defaultMapUrl;
  @Input() options: MapOptions= {
      layers:[tileLayer(`${this.mapUrl}/styles/m2openmaptiles/{z}/{x}/{y}.png`, {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    })],
    zoom:17,
    center:latLng(this.getCoords()),
  };

  setIcon(){
    const zoom = this.map.getZoom();
    return Icon.extend({
      options:
        {
          iconSize: [zoom+10, zoom+20], // size of the icon
          iconAnchor: [zoom / 2, zoom], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -zoom],  
          iconUrl: '../../../../assets/images/marker-icon.png'
        }
    })
  }



  onMapReady(map: Map) {
      this.map = map;
      this.map$.emit(map);
      this.zoom = map.getZoom();
      this.zoom$.emit(this.zoom);
      //var popup_data:string
      
      //popup_data=this.setPopUpData();//"<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Targa: "+this.data.licenseplate+"</td></tr><tr><td><b/>Modello: "+this.data.model+"</td></tr><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Data Punto: "+moment(this.data.last_gps_update).format('DD/MM/yyyy, HH:mm:ss')+"</td></tr></table></div>";
      const marker_icon=this.setIcon();
      marker(this.getCoords(), {icon:new marker_icon}).bindPopup(this.data.pop_up_data, {closeButton: false}).addTo(map);
    }

  onMapZoomEnd(e: LeafletEvent) {
    this.zoom = e.target.getZoom();
    this.zoom$.emit(this.zoom);
  }
}

export type DialogMapParams = {
  data: any;
};
